import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=d9443508&scoped=true"
import script from "./Onboarding.vue?vue&type=script&lang=js"
export * from "./Onboarding.vue?vue&type=script&lang=js"
import style0 from "./Onboarding.vue?vue&type=style&index=0&id=d9443508&prod&scoped=true&lang=css"
import style1 from "./Onboarding.vue?vue&type=style&index=1&id=d9443508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9443508",
  null
  
)

export default component.exports